import ApiService from '@/core/api/api.service';
import TokenService from '@/core/api/token.service';
import store from '@/store';

import { functionsWithNotifications, Notification } from '@/core/notifications';
import authMessages from './auth.messages';

const functions = {
  activate,
  login,
  passwordReset,
  passwordResetConfirm,
  register,
  verifyEmail,
};

export default {
  ...functionsWithNotifications(functions, authMessages),
};

const authApi = new ApiService({
  baseUrl: store.getters.umBaseUrl,
  addAuthToken: false,
});

async function activate(params) {
  const response = await authApi.post('registration/confirm', params);
  return response.data.user;
}

async function login(authCredentials) {
  // The correct value for the rememberMe flag is 'yes'/'no' instead of true/false
  // See https://xperior.tpondemand.com/entity/19716
  const requestBody = {
    ...authCredentials,
    rememberMe: authCredentials.rememberMe ? 'yes' : 'no',
  };

  const response = await authApi.post('auth', requestBody);

  const expires = new Date(response.data.expires);
  const { token } = response.data;
  TokenService.setAuthToken(token, expires);
  return response.data.user;
}

async function passwordReset(email, withReferrer) {
  const requestBody = {
    login: email,
    referrer: withReferrer ? window.location.origin : undefined,
  };
  await authApi.post('auth/forgot_password', requestBody);
}

async function passwordResetConfirm(params) {
  await authApi.put('auth/forgot_password', params);
}

async function register(params) {
  const response = await authApi.post('registration', params);

  const expires = new Date(response.data.expires);
  const { token } = response.data;
  TokenService.setAuthToken(token, expires);
  return response.data.user;
}

async function verifyEmail(params) {
  const response = await authApi.post('registration/confirm', params);
  const authToken = TokenService.getAuthToken();
  const notification = authMessages.verifyEmail.success.message(authToken);
  Notification.success(notification);
  return response.data.user;
}
